<template>
  <a href="http://translate.google.com/" aria-label="Google Translate" target="_blank" rel="noopener noreferrer">
    <google-translate-logo />
  </a>
</template>
<script setup lang="ts">
import googleTranslateLogo from '@/common/assets/logos/google-translate.svg?component';
</script>
